import React, { useState } from "react";
import { Box, Typography, Collapse, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../layout/components/CustomButton";
import {
  setSelectedGroup,
  navigatedToNextStep,
  setSelectedParcelLocker,
} from "../../../../redux/slice/bookingCreation/bookingCreationSlice";
import { RootState } from "../../../../redux/store";
import InfoIcon from "../../../../components/icons/InfoIcon";

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "16px",
    boxSizing: "border-box",
    height: "100%",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    flex: 1,
    width: "100%",
    maxWidth: "400px",
  },
  title: {
    fontFamily: "IBM Plex Sans, sans-serif",
    fontWeight: 600,
    fontSize: "24px",
    lineHeight: "32px",
    marginBottom: "32px",
    color: "#333333",
  },
  lockerOptions: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    width: "100%",
    marginBottom: "32px",
  },
  buttonContainer: {
    position: "fixed",
    bottom: "16px",
    left: "0",
    right: "0",
    display: "flex",
    justifyContent: "center",
    padding: "0 16px",
  },
};

function LockerSelection() {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const theme = useTheme();
  const selectedParcelLocker = useSelector(
    (state: RootState) => state.bookingCreation.selectedParcelLocker
  );
  const verifyPinResponseData = useSelector(
    (state: RootState) => state.bookingCreation.verifyPinResponseData
  );
  const [expandedLocker, setExpandedLocker] = useState<string | null>(null);

  const handleLockerSelect = (locker: any) => {
    dispatch(setSelectedParcelLocker(locker));
    setExpandedLocker(expandedLocker === locker.id ? null : locker.id);
  };


  return (
    <Box sx={styles.container}>
      <Box sx={styles.content}>
        <Box sx={styles.lockerOptions}>
          {verifyPinResponseData?.groups?.length === 0 ? (
            <Typography>No lockers available for this location.</Typography>
          ) : (
            verifyPinResponseData?.groups?.map((locker: any) => (
              <Box key={locker.id} sx={{ marginBottom: 2 }}>
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                  <Box
                    sx={(theme) => ({
                      display: "flex",
                      width: "calc(100% - 42px)",
                      border: `1px solid ${theme.palette.primary.main}`,
                      paddingTop: 1,
                      paddingBottom: 1,
                      borderRadius: 1,
                      justifyContent: "center",
                      textAlign: "center",
                      alignItems: "center",
                      cursor: "pointer",
                      color: "black",
                      backgroundColor:
                        selectedParcelLocker?.id === locker.id
                          ? theme.palette.primary.light
                          : "transparent",
                    })}
                    onClick={() => handleLockerSelect(locker)}
                  >
                    <Typography
                      sx={{
                        fontWeight: "bold",
                        display: "inline",
                        color:
                          selectedParcelLocker?.id === locker.id
                            ? theme.palette.button.text
                            : "inherit",
                      }}
                    >
                      {locker.name || locker.size || locker.id}
                    </Typography>
                  </Box>
                </Box>
                <Collapse
                  in={expandedLocker === locker.id}
                  sx={{ width: "calc(100% - 42px)", paddingLeft: 3 }}
                >
                  <Box sx={{ display: "flex", paddingTop: 1 }}>
                    <Box sx={{ marginRight: "5px", color: "#1E1E1E" }}>
                      <InfoIcon
                        style={{
                          width: "20px",
                          height: "20px",
                        }}
                      />
                    </Box>
                    <Typography variant="body2" fontWeight="bold">
                      {locker.name || locker.size || locker.id}:{" "}
                      {locker.langNames?.[i18n.language]?.description || ""}
                    </Typography>
                  </Box>
                </Collapse>
              </Box>
            ))
          )}
        </Box>
      </Box>
    </Box>
  );
}

export default LockerSelection;
